export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11036.34f8e452.jpg";